import { useEffect, useRef, useState } from 'react'

const SCROLL_BOTTOM_THRESHOLD = 100

export const useScrollToBottom = (contentKey: string) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const [showScrollButton, setShowScrollButton] = useState(false)

  const scrollToBottom = () => {
    containerRef.current?.scrollTo({
      behavior: 'smooth',
      top: containerRef.current.scrollHeight
    })
  }

  useEffect(() => {
    const container = containerRef.current

    const updateScrollButtonVisibility = () => {
      if (!container) return
      const { scrollTop, scrollHeight, clientHeight } = container
      setShowScrollButton(scrollHeight - scrollTop > clientHeight + SCROLL_BOTTOM_THRESHOLD)
    }

    updateScrollButtonVisibility()
    container?.addEventListener('scroll', updateScrollButtonVisibility)

    return () => container?.removeEventListener('scroll', updateScrollButtonVisibility)
  }, [contentKey])

  return { containerRef, showScrollButton, scrollToBottom }
}
